import { useEffect, useRef } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const HEARTBEAT_MS = 20000;

export const useHeartbeat = () => {
  const { user } = useAuth();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!user) return undefined;
    const ping = () => {
      api.post("/presence/heartbeat").catch(() => {});
    };
    ping();
    timerRef.current = setInterval(ping, HEARTBEAT_MS);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [user]);
};
